import { Star } from "lucide-react";
import { useFavorites } from "../context/FavoritesContext";

const cache = new WeakMap();
const cached = (m, build) => {
  if (!cache.has(m)) cache.set(m, build(m));
  return cache.get(m);
};
export const catalogFavorite = (m) =>
  cached(m, () => ({ kind: "catalog", ref: m.id, name: m.name, meta: { family: m.family, params: m.params } }));
export const trendingFavorite = (m) =>
  cached(m, () => ({ kind: "trending", ref: m.id, name: m.name, meta: { author: m.author, params: m.params, pipeline_tag: m.pipeline_tag } }));

export function FavoriteButton({ item, className = "" }) {
  const { isFavorite, toggle } = useFavorites();
  const on = isFavorite(item.kind, item.ref);
  return (
    <button
      type="button"
      onClick={() => toggle(item)}
      data-testid="favorite-toggle-button"
      aria-pressed={on}
      aria-label={on ? "Retirer des favoris" : "Ajouter aux favoris"}
      title={on ? "Retirer des favoris" : "Ajouter aux favoris"}
      className={`rounded-md p-1 transition-colors hover:text-amber-300 ${on ? "text-amber-400" : "text-muted-foreground"} ${className}`}
    >
      <Star className={`h-4 w-4 transition-transform active:scale-90 ${on ? "fill-amber-400" : ""}`} />
    </button>
  );
}
